import React from 'react';
import { SvgImg } from 'components/SvgImg';

const Loader = (props) => {
    return (
        <div className="loader-container">
          <div className="loader-content">
            <div className="loader">
              <SvgImg className="svg" src="/clients/prime/release/assets/content/icons/loading.svg" />
            </div>
          </div>
        </div>
    )
}

export default Loader;